import { createService, z } from '@bonanza-social/toolkit/api';
import { GameplaySchema } from './GameplayService.schemas';

export default {
  ...createService(
    {
      getGameplay: {
        method: 'POST',
        url: '/gamelaunch',
        responseSchema: GameplaySchema,
      },
    },
    ({ userId }) => `/Players/${userId}`,
  ),
  ...createService({
    updateSession: {
      method: 'PATCH',
      url: '/session',
      responseSchema: z.any(),
    },
  }),
};
